import React from "react";
import CalculCapaciteEmprunt from "../components/CalculCapaciteEmprunt";

export default function CalculCapaciteEmpruntPage() {
  return <CalculCapaciteEmprunt />;
}
